import { useState } from 'react';
import { SectionDemoLink } from '../CTAButtons/CTAButtons';
import styles from './FAQ.module.css';

const faqItems = [
  {
    question: 'Does ONI replace POS?',
    answer:
      'ONI complements your existing concession POS. It handles in-seat mobile ordering, seat routing, and fulfillment workflows while your current POS continues to manage kitchen and register operations.',
  },
  {
    question: 'How do runners work?',
    answer:
      'Every order includes section, row, and seat details. Runners receive routed orders through the live queue, pick up from vendors, and update delivery status as they move through the stadium.',
  },
  {
    question: 'Can vendors opt in?',
    answer:
      'Yes. Venue operators control which vendors are live for each event. Concessions can opt in when they are ready and manage their own menus and availability from the admin dashboard.',
  },
  {
    question: 'Can multiple restaurants participate?',
    answer:
      'Yes. ONI supports a multi-vendor marketplace under one venue platform, so fans can browse and order from multiple concessions in a single flow.',
  },
  {
    question: 'How is payment handled?',
    answer:
      'Stripe is the default for secure fan checkout in the ordering flow. We can also integrate directly with your payment system of choice on a stadium-to-stadium basis, with settlement and reporting configured per venue contract so your finance team stays in control.',
  },
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className={`section ${styles.section}`} aria-labelledby="faq-heading">
      <div className="container">
        <span className="sectionLabel">FAQ</span>
        <h2 id="faq-heading" className="sectionTitle">
          Common questions from venue teams
        </h2>
        <p className="sectionSubtitle">
          Answers to the questions stadium and arena operators ask most when evaluating in-seat ordering.
        </p>

        <div className={styles.list}>
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;
            const panelId = `faq-panel-${index}`;
            const buttonId = `faq-button-${index}`;

            return (
              <article key={item.question} className={styles.item}>
                <h3>
                  <button
                    id={buttonId}
                    type="button"
                    className={styles.trigger}
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                  >
                    {item.question}
                    <span className={`${styles.icon} ${isOpen ? styles.iconOpen : ''}`} aria-hidden="true" />
                  </button>
                </h3>
                <div
                  id={panelId}
                  role="region"
                  aria-labelledby={buttonId}
                  className={`${styles.panel} ${isOpen ? styles.panelOpen : ''}`}
                >
                  <div className={styles.panelInner} aria-hidden={!isOpen}>
                    <p>{item.answer}</p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
        <SectionDemoLink className={styles.demoLink} />
      </div>
    </section>
  );
}

export default FAQ;
